import { ContractStatus } from 'compliance-api/generated';
import { SelectOption } from 'ui';
import { fixNameEnum } from 'ui/utils';

export const contractStatusOptions: SelectOption<ContractStatus>[] = Object.values(
  ContractStatus,
).map(status => ({
  value: status,
  label: fixNameEnum(status),
}));

export const formatContractStatusLabel = (status: ContractStatus | string) => {
  const label = fixNameEnum(status);
  return label.charAt(0).toUpperCase() + label.slice(1);
};
